/* eslint-disable @typescript-eslint/no-explicit-any */
import U2000InputText from '../../../u2000Core/components/formControls/input/U2000InputText';
import U2000InputDecimal from '../../../u2000Core/components/formControls/input/U2000InputDecimal';
import type { TFunction } from 'i18next';
import { NS } from '../../U2107';
import { U2000FormStateEnumEditMode, U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import type { U2107LogicalUnitCategory } from '../../U2107Service';

interface U2107LogicalUnitCategoryBodyProps {
  formStateHandlers: U2000FormStateHandlers<U2107LogicalUnitCategory>;
  t: TFunction;
}

function U2107LogicalUnitCategoryBody({ formStateHandlers, t }: U2107LogicalUnitCategoryBodyProps) {
  const isAdd = formStateHandlers.getFormEditMode() === U2000FormStateEnumEditMode.ADD;
  const readonly = formStateHandlers.getFormState() === U2000FormStateEnumState.READ;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <U2000InputText
        formStateHandlers={formStateHandlers as any}
        fieldName="code"
        label={t('lblCode', { ns: NS })}
        required={isAdd}
        readonly={readonly || !isAdd}
      />
      <U2000InputDecimal
        formStateHandlers={formStateHandlers as any}
        fieldName="sortOrder"
        label={t('lblSortOrder', { ns: NS })}
        required
        decimalDigits={0}
        allowNegative={false}
      />
      <U2000InputText
        formStateHandlers={formStateHandlers as any}
        fieldName="labelFr"
        label={t('lblLabelFr', { ns: NS })}
        required
      />
      <U2000InputText
        formStateHandlers={formStateHandlers as any}
        fieldName="labelEn"
        label={t('lblLabelEn', { ns: NS })}
        required
      />
    </div>
  );
}

export default U2107LogicalUnitCategoryBody;
